
/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {
    Timeline,
    TimelineMax,
    TimelineLite,
    TweenLite,
    TweenMax,
    Ease,
    Linear,
    Power2,
    Power1,
    Power0,
    Power3,
    Power4,
    Expo,
    Elastic
} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {SAReelEvent} from "../reel/SAReelController";
import {SAFreespinEvent} from "../background/SABackground";


export class FreespinSpinStart implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _freespinsLeft:number;
    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:SpacierArcadeParsedGameData):void {
        this._freespinsLeft = data.freespinsLeft;
    }


    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        const tl:TimelineLite = new TimelineLite();
        tl.add(()=>{
            EventHandler.dispatchEvent(new GameEvent(SAFreespinEvent.UPDATE_FREE_SPIN_COUNT, this._freespinsLeft - 1));
            SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft - 1);
        });
        tl.add(()=>{
            if(SoundConfig.instance.REELS_SPIN_START) {
                SlotGame.sound.playEffect(SoundConfig.instance.REELS_SPIN_START[0]);
            }
        });
        return tl;
    }
}